export { default } from "./AppCheckbox";

export type { AppCheckboxProps } from "./AppCheckbox";
